import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * PATCH /system/user/me — 變更本人可編欄（display_name 必填、work_email 選填）。
 * @see docs/API_SYSTEM_USER.md § Update own profile
 * @param {{ displayName: string, workEmail?: string | null }} params
 */
export async function updateOwnProfile({ displayName, workEmail }) {
  const trimmedDisplayName = String(displayName ?? '').trim();
  const trimmedWorkEmail = workEmail == null
    ? ''
    : String(workEmail).trim();

  const { data: raw } = await request.patch(
    '/system/user/me',
    keysToSnake({
      displayName: trimmedDisplayName,
      workEmail: trimmedWorkEmail === '' ? null : trimmedWorkEmail,
    }),
  );
  return parseVer4DetailResponse(raw);
}
